import { init } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"

import "./styles/index.css"

init({
    ...window.nostoTemplatesConfig,
    categoryComponent: Category,
    compressUrlParameters: true,
    fallback: true,
    // Uncomment for Category Merchandising
    categoryCssSelector: '#nostoTargetPLP',
       categoryQuery() {
        return {
            name: 'serp',
            products: {
                categoryId: this.categoryId(),
                categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
    //   queryModifications(query) {
    //     return {
    //         ...query,
    //         products: {
    //             ...(query.products ?? {}),
    //             filter: [
    //                 ...(query.products.filter ?? []),
    //                 {
    //                     field: "extra.torso-length",
    //                     value: ["classic"]
    //                 }
    //             ]
    //         }
    //     }
    //   },
})
